import React, { useRef, useMemo, useEffect } from 'react'
import styled from '@emotion/styled'
import canvasRetina from 'canvas-retina'

import * as THREE from 'three'

const Canvas = styled.canvas`
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  font-weight: 800;
  font-family: auto;
  letter-spacing: 1px;
`

export default function Labels (props) {
  const ref = useRef()
  const currentRef = ref.current

  const ctx = useMemo(() => {
    if (currentRef) return canvasRetina(currentRef).ctx
  }, [currentRef])

  useEffect(() => {
    if (!props.threeRefs.current || !ctx) return
    let raf

    function draw () {
      const bb = currentRef.getBoundingClientRect()
      currentRef.width = bb.width * window.devicePixelRatio
      currentRef.height = bb.height * window.devicePixelRatio
      ctx.scale(window.devicePixelRatio, window.devicePixelRatio)

      props.labels.forEach((d) => {
        if (d.zoom[0] <= props.zoom && props.zoom <= d.zoom[1]) {
          const position = new THREE.Vector3(...props.manager.nodeIdToNode[d.id].getPosition(props.manager.nodePositions))
          const fontSize = d.fontSize || 12
          const bold = d.bold ? 'bold' : ''

          var size = new THREE.Vector3()
          props.threeRefs.current.gl.getSize(size)
          var projScreenMat = new THREE.Matrix4()
          projScreenMat.multiplyMatrices(props.threeRefs.current.camera.projectionMatrix, props.threeRefs.current.camera.matrixWorldInverse)
          position.applyMatrix4(projScreenMat)

          const x = (position.x + 1) * size.x / 2
          const y = -15 + (-position.y + 1) * size.y / 2

          ctx.font = `${fontSize}px Gilroy`
          const width = ctx.measureText(d.value).width
          const height = fontSize
          const paddingHeight = 10
          const paddingWidth = 20

          ctx.fillStyle = d.color || 'rgba(0, 0, 0, 0.4)'
          ctx.beginPath()
          ctx.strokeStyle = 'rgba(255, 255, 255, 0.5)'
          ctx.lineWidth = d.strokeWidth
          ctx.rect(
            x - (width + paddingWidth) * 0.5,
            y - (height + paddingHeight) * 0.55,
            width + paddingWidth,
            fontSize + paddingHeight)
          ctx.fill()
          d.strokeWidth > 0 && ctx.stroke()

          ctx.fillStyle = 'white'
          ctx.font = `${bold} ${fontSize}px Gilroy`
          ctx.fillText(
            d.value,
            x - width * 0.5,
            y + height * 0.25
          )
        }
      })

      raf = window.requestAnimationFrame(draw)
    }

    raf = window.requestAnimationFrame(draw)

    return () => {
      if (raf) window.cancelAnimationFrame(raf)
    }
  }, [currentRef, ctx, props.labels, props.threeRefs, props.manager, props.zoom])

  return <Canvas ref={ref} />
}
